export const useInIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};
